var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 6.33301H8.66667V7.66634H3.33333V9.66634L0 6.99967L3.33333 4.33301V6.33301ZM2.66618 10.9997H4.47223C5.41241 11.8295 6.64741 12.333 8 12.333C10.9455 12.333 13.3333 9.94521 13.3333 6.99967C13.3333 4.05415 10.9455 1.66634 8 1.66634C6.64741 1.66634 5.41241 2.16985 4.47223 2.99967H2.66618C3.88245 1.38041 5.81891 0.333008 8 0.333008C11.6819 0.333008 14.6667 3.31777 14.6667 6.99967C14.6667 10.6815 11.6819 13.6663 8 13.6663C5.81891 13.6663 3.88245 12.6189 2.66618 10.9997Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon11);
export default __webpack_public_path__ + "static/media/sidebar-icon-11.2baeec82f2b47fcbbc903b745cf539f9.svg";
export { ForwardRef as ReactComponent };